import { useCallback } from "react";
import { AI_PLAYGROUND_CONSTANTS as CONSTANTS } from "../AIPlayground.constants";
import { copyFormattedToClipboard } from "../../../Utils/js-common";

export const useClipboard = () => {
  const copyToClipboard = useCallback((text: string) => {
    if (!text.trim()) {
      alert(CONSTANTS.MESSAGES.NOTHING_TO_COPY);
      return;
    }

    copyFormattedToClipboard(text)
      .then(() => {
        alert(CONSTANTS.MESSAGES.COPIED);
      })
      .catch(() => {
        alert(CONSTANTS.MESSAGES.COPY_FAILED);
      });
  }, []);

  return { copyToClipboard };
};
